import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private readonly THEME_KEY = 'app-theme';
  private availableThemes = [
    'supidoo',
    // 'instamart',
    // 'blinkit',

    // 'paysnap',
    'light',
    'dark',
    'cupcake',
    'emerald',
    'abyss',
    'autumn',
  ];
  private defaultTheme = 'supidoo';

  constructor() {
    this.loadTheme();
  }

  /** Get current theme */
  get currentTheme(): string {
    return localStorage.getItem(this.THEME_KEY) || this.defaultTheme;
  }

  /** Change theme and save preference */
  setTheme(theme: string): void {
    if (!this.availableThemes.includes(theme)) {
      console.warn(`Theme "${theme}" not found, falling back to default.`);
      theme = this.defaultTheme;
    }

    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem(this.THEME_KEY, theme);
  }
  getCurrentTheme() {
    const currentTheme =
      localStorage.getItem(this.THEME_KEY) || this.defaultTheme;

    return currentTheme;
  }
  /** Load theme from localStorage on startup */
  private loadTheme(): void {
    const savedTheme =
      localStorage.getItem(this.THEME_KEY) || this.defaultTheme;
    document.documentElement.setAttribute('data-theme', savedTheme);
  }

  /** Get list of available themes */
  getThemes(): string[] {
    return this.availableThemes;
  }
}
